import Vue from 'vue'
import { Input,Autocomplete  } from 'element-ui'
import VueRouter from 'vue-router'

Vue.use(Input)
Vue.use(Autocomplete )
Vue.use(VueRouter)

import App from './App'
import Vuex from 'vuex'
Vue.use(Vuex)

import vuexI18n from 'vuex-i18n'



import VueResource from 'vue-resource'
import store from './store/store'

import $ from 'jquery'
import 'font-awesome/css/font-awesome.css'




import router from './router/index'


import axios from 'axios'

Vue.prototype.$axios = axios// 绑定到全局 各个地方都能使用









/**
* you can add your module here
*/

store.registerModule('vux', {
state: {
demoScrollTop: 0,
isLoading: false,
direction: 'forward'
},
mutations: {
updateDemoPosition(state, payload) {
state.demoScrollTop = payload.top
},
updateLoadingStatus(state, payload) {
state.isLoading = payload.isLoading
},
updateDirection(state, payload) {
state.direction = payload.direction
}
},
actions: {
updateDemoPosition({ commit }, top) {
commit({ type: 'updateDemoPosition', top: top })
}
}
})




import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import LocalePlugin from 'vux/src/plugins/locale/index.js'
import DevicePlugin from 'vux/src/plugins/device/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import AppPlugin from 'vux/src/plugins/app/index.js'


Vue.use(DevicePlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(WechatPlugin)
Vue.use(AjaxPlugin)
Vue.use(LocalePlugin)
Vue.use(DatetimePlugin)






const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)

router.beforeEach(function (to, from, next) {
store.commit('updateLoadingStatus', { isLoading: true })

const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)

if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.commit('updateDirection', { direction: 'forward' })
} else {
store.commit('updateDirection', { direction: 'reverse' })
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('updateDirection', { direction: 'forward' })
}
setTimeout(function () {
next()
}, 0);


})

router.afterEach(function (to) {
store.commit('updateLoadingStatus', { isLoading: false })





})
Vue.use(VueResource)




Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
store,
router,
render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js